//
//
//
//
//
//
//
//
//
//
//

import explain from './components/explain';
export default {
  name: 'Explain',
  components: {
    explain: explain
  }
};